"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RecipientActionsSelector = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _reactHookForm = require("react-hook-form");

var _ramda = require("ramda");

var _requiredActions = require("../../../CreateGift/containers/SelectRecipientRequirements/required-actions.constants");

var styles = {
  select: {
    ["& .".concat(_material.selectClasses.outlined, ".Mui-disabled")]: {
      WebkitTextFillColor: 'initial'
    }
  },
  chipWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 0.25
  },
  chip: {
    ["&.".concat(_material.buttonBaseClasses.root)]: {
      margin: 0.3,
      color: function color(_ref) {
        var palette = _ref.palette;
        return palette.common.white;
      },
      backgroundColor: function backgroundColor(_ref2) {
        var palette = _ref2.palette;
        return palette.green.mountainMeadowLight;
      },
      '&:hover': {
        backgroundColor: function backgroundColor(_ref3) {
          var palette = _ref3.palette;
          return palette.green.mountainMeadowLight;
        }
      }
    },
    ["& .".concat(_material.chipClasses.deleteIcon)]: {
      width: 14,
      height: 14,
      color: function color(_ref4) {
        var palette = _ref4.palette;
        return palette.common.white;
      },
      '&:hover': {
        color: function color(_ref5) {
          var palette = _ref5.palette;
          return palette.common.white;
        }
      }
    },
    ["&.".concat(_material.chipClasses.disabled)]: {
      border: '1px solid #d8d8d8',
      backgroundColor: 'transparent',
      color: function color(_ref6) {
        var palette = _ref6.palette;
        return palette.grey.main;
      },
      opacity: 1,
      ["& .".concat(_material.chipClasses.deleteIcon)]: {
        color: '#d8d8d8'
      }
    }
  }
};

var RecipientActionsSelector = function RecipientActionsSelector(_ref7) {
  var name = _ref7.name,
      control = _ref7.control,
      disabled = _ref7.disabled;

  var _useController = (0, _reactHookForm.useController)({
    control,
    name
  }),
      _useController$field = _useController.field,
      onChange = _useController$field.onChange,
      actions = _useController$field.value;

  var handleDeleteAction = (0, _react.useCallback)(function (e, value) {
    e.preventDefault();
    onChange((0, _ramda.without)([value], actions));
  }, [actions, onChange]);
  var handleChipMouseDown = (0, _react.useCallback)(function (e) {
    return e.stopPropagation();
  }, []);
  var deleteIcon = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "times",
      onMouseDown: handleChipMouseDown
    });
  }, [handleChipMouseDown]);
  var renderValue = (0, _react.useCallback)(function (selected) {
    if (selected.length === 0) {
      return /*#__PURE__*/_react.default.createElement(_material.Box, null, "None");
    }

    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: styles.chipWrapper
    }, selected.map(function (value) {
      var _REQUIRED_ACTIONS$fin;

      var title = (_REQUIRED_ACTIONS$fin = _requiredActions.REQUIRED_ACTIONS.find(function (a) {
        return a.id === value;
      })) === null || _REQUIRED_ACTIONS$fin === void 0 ? void 0 : _REQUIRED_ACTIONS$fin.title;
      return /*#__PURE__*/_react.default.createElement(_material.Chip, {
        sx: styles.chip,
        key: value,
        label: title,
        clickable: true,
        deleteIcon: deleteIcon,
        onDelete: function onDelete(event) {
          return handleDeleteAction(event, value);
        },
        disabled: disabled
      });
    }));
  }, [deleteIcon, handleDeleteAction, disabled]);

  var handleActionsChange = function handleActionsChange(e) {
    var value = e.target.value;
    onChange(value);
  };

  var getIsActionChecked = function getIsActionChecked(actionId) {
    return actions.includes(actionId);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    fullWidth: true,
    variant: "outlined"
  }, /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
    id: "gift-actions-select-recipient-actions",
    shrink: true
  }, "Required actions to accept gift"), /*#__PURE__*/_react.default.createElement(_material.Select, {
    label: "Required actions to accept gift",
    labelId: "gift-actions-select-recipient-actions",
    multiple: true,
    displayEmpty: true,
    renderValue: renderValue,
    value: actions,
    onChange: handleActionsChange,
    disabled: disabled,
    input: /*#__PURE__*/_react.default.createElement(_material.OutlinedInput, {
      label: "Required actions to accept gift",
      notched: true
    }),
    sx: styles.select
  }, _requiredActions.REQUIRED_ACTIONS.map(function (action) {
    return /*#__PURE__*/_react.default.createElement(_material.MenuItem, {
      key: action.id,
      value: action.id
    }, /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
      checked: getIsActionChecked(action.id)
    }), action.title);
  }))));
};

exports.RecipientActionsSelector = RecipientActionsSelector;